export default {
  productName: '$t("header._axatp009")',
  productImg: require('../../../assets/image/astp/axatp009.jpg'),

  insuranceName: '$t("labels.axatp009")',
  insuranceDownloadName: '“盛游全球”个人境外旅行保险保险条款.pdf',
  insuranceFile: 'https://image.ssish.com/static/product/axatp009/pdf/axatp009_tk.pdf',

  claimGuideName: '$t("labels.h")',
  claimGuideDownloadName: '索赔申请书填写示例.pdf',
  claimGuideFile: 'https://cps.ssish.com/axa/files/索赔申请书填写示例.pdf',

  claimFormName: '',
  claimFormDownloadName: '',
  claimFormFile: 'https://cps.ssish.com/axa/files/索赔申请书下载.pdf',

  destination: '$t("addPolicy.v")',
  disabledDest: true,

  lpShow: true, // 详情页理赔指引理赔部门模块是否显示
  ageRange: '$t("labels.b")',
  showInvoiceModal: true,
  showHowPolicy: true,
  underCompanyName: "安盛天平财产保险有限公司"
}